import { CancelToken } from 'axios';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import {
  IOryRedirect,
  OryCancelableResponse,
  OryCancelableResponseWithData,
  OryContext,
  OryResponse,
  OryResponseWithData,
} from '../../../types';
import { getCurrentUserOrySession, loginToOry, loginToOryWithSAML, logoutFromOry } from './loginApi';

export interface ILoginToOryProps {
  email?: string;
  password?: string;
  sessionRefresh?: boolean;
  context?: OryContext;
  totp?: string;
  totpRecoveryCode?: string;
}

export interface ICancelTokenProps {
  cancelToken?: CancelToken;
}

export interface ICancelTokenProps {
  cancelToken?: CancelToken;
}

export interface IOrySessionInfo {
  isUserLoggedAsOrySso?: boolean;
}

export interface ILoginToOryWithSamlProps {
  organizationId: string;
  refreshSession: boolean | undefined;
}

export interface IUseLoginApi {
  loginToOry: (props: ILoginToOryProps) => Promise<OryResponse>;
  logoutFromOry: (props?: ICancelTokenProps) => Promise<OryCancelableResponse>;
  getOryCurrentUserSession: (props?: ICancelTokenProps) => Promise<OryCancelableResponseWithData<IOrySessionInfo>>;
  loginToOryWithSAML: (props: ILoginToOryWithSamlProps) => Promise<OryResponseWithData<IOryRedirect>>;
  isOryApiFetching: boolean;
}

export function useOryLoginApi(): IUseLoginApi {
  const [isFetching, setIsFetching] = useState(false);
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();

  return {
    getOryCurrentUserSession: (props) => getCurrentUserOrySession(setIsFetching, dispatch, formatMessage, props),
    isOryApiFetching: isFetching,
    loginToOry: (props) => loginToOry(props, setIsFetching, dispatch, formatMessage),
    loginToOryWithSAML: (props) => loginToOryWithSAML(setIsFetching, dispatch, formatMessage, props),
    logoutFromOry: (props) => logoutFromOry(setIsFetching, dispatch, formatMessage, props),
  };
}
